<template>
  <div class="filters">
    <b-field grouped position="is-left">
      <b-input
        expanded
        size="is-small"
        :placeholder="$t('RouteFilters.route_input_placeholder')"
        v-model="criteria.name"
      ></b-input>

      <b-clockpicker
        expanded
        editable
        size="is-small"
        :placeholder="$t('RouteFilters.clock_input_placeholder')"
        icon="clock"
        hour-format="12"
        v-model="criteria.departurehour"
      ></b-clockpicker>

      <b-taginput
        expanded
        size="is-small"
        v-model="criteria.tags"
        icon="label"
        :placeholder="$t('RouteFilters.tag_input_placeholder')"
      ></b-taginput>

      <b-checkbox-button
        @input="search()"
        size="is-small"
        v-model="tagsDays"
        native-value="0"
        type="is-secondary"
      >{{$t('RouteFilters.monday')}}</b-checkbox-button>

      <b-checkbox-button
       @input="search()"
        size="is-small"
        v-model="tagsDays"
        native-value="1"
        type="is-secondary"
      >{{$t('RouteFilters.tuesday')}}</b-checkbox-button>

      <b-checkbox-button
       @input="search()"
        size="is-small"
        v-model="tagsDays"
        native-value="2"
        type="is-secondary"
      >{{$t('RouteFilters.wednesday')}}</b-checkbox-button>

      <b-checkbox-button
       @input="search()"
        size="is-small"
        v-model="tagsDays"
        native-value="3"
        type="is-secondary"
      >{{$t('RouteFilters.thursday')}}</b-checkbox-button>

      <b-checkbox-button
       @input="search()"
        size="is-small"
        v-model="tagsDays"
        native-value="4"
        type="is-secondary"
      >{{$t('RouteFilters.friday')}}</b-checkbox-button>

      <b-checkbox-button
       @input="search()"
        size="is-small"
        v-model="tagsDays"
        native-value="5"
        type="is-secondary"
      >{{$t('RouteFilters.saturday')}}</b-checkbox-button>

      <b-checkbox-button
       @input="search()"
        size="is-small"
        v-model="tagsDays"
        native-value="6"
        type="is-secondary"
      >{{$t('RouteFilters.sunday')}}</b-checkbox-button>

      <p class="control">
        <button class="button is-primary is-small" @click="search">
          <b-icon icon="magnify" size="is-small" :title="$t('RouteFilters.search_tooltip')"></b-icon>
        </button>
      </p>
    </b-field>
  </div>
</template>

<script>

export default {
  name: 'RouteFilters',
  data: function () {
    return {
      tagsDays: [],
      criteria: {
        name: '',
        departurehour: null,
        tags: [],
        days: []
      }
    }
  },
  methods: {

    search () {
      // alert("call search from component");
      this.transformDaysToArray()
      const cloneCriteria = JSON.parse(JSON.stringify(this.criteria))
      this.$store.commit('planning/searchRoutes', cloneCriteria)
    },

    /**
     * Transform day values (0,1...6) of criteria to Boolean Array (false,false,true,...)
     * If all value are false, return empty array
     */
    transformDaysToArray () {
      if (this.tagsDays && this.tagsDays.length > 0) {
        let empty = true
        for (let i = 0; i < 7; i++) {
          this.criteria.days[i] = this.tagsDays.includes('' + i)
          empty &= !this.criteria.days[i]
        }
        if (empty) {
          this.criteria.days = []
        }
      } else {
        this.criteria.days = []
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
p {
  color: #448893;
}
</style>
